export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does E & J Painting serve?",
    a: "We're based in Murfreesboro, TN and serve the surrounding Middle Tennessee area — including Nashville, Franklin, Brentwood, Smyrna, La Vergne, Nolensville, Mount Juliet, Lebanon, Hendersonville, Gallatin, Spring Hill, Columbia, Clarksville, and Dickson.",
  },
  {
    q: "How much does painting cost?",
    a: "Every project is priced individually based on square footage, surface condition, how many coats are needed, and the type of paint you choose. We come out, measure, and give you a free written estimate — so you know the full price before any work starts. There are no hidden charges.",
  },
  {
    q: "Do you offer free estimates?",
    a: "Yes. Estimates are always free and there's no obligation. Call (615) 930-6254 or send us a message through the site and we'll schedule a walkthrough at a time that works for you.",
  },
  {
    q: "Do you have a discount available?",
    a: "Yes — the first three customers to book each month receive 15% off their project. Just mention it when you call. Returning customers and referrals from past customers qualify as well.",
  },
  {
    q: "What are your business hours?",
    a: "We're open Monday through Friday, 8:00 AM to 5:00 PM. Commercial projects can often be scheduled for evenings or weekends so your business doesn't have to close — just ask when you call.",
  },
  {
    q: "Do you handle both interior and exterior painting?",
    a: "Both. We do interior work — walls, ceilings, trim, doors, and cabinets — as well as full exterior projects including siding, trim, soffits, fascia, shutters, decks, and porches.",
  },
  {
    q: "Can you repair drywall before painting?",
    a: "Yes, and we recommend it. Paint only looks as good as the surface underneath. We patch holes, repair cracks and water damage, fix nail pops, and match existing texture — knockdown, orange peel, or smooth — so the repair disappears instead of standing out.",
  },
  {
    q: "Do you paint commercial properties?",
    a: "Absolutely. We paint offices, retail spaces, restaurants, warehouses, and apartment complexes. Commercial work is typically scheduled after hours or on weekends so your operation keeps running.",
  },
  {
    q: "How long will my project take?",
    a: "A single room is often done in a day. A whole-home interior usually takes several days, and a full exterior depends on square footage and weather. We give you a realistic timeline in your written estimate and keep you updated if anything changes.",
  },
  {
    q: "Do you protect furniture and floors?",
    a: "Always. Furniture is moved and covered, floors are masked, and fixtures and hardware are protected before we open a can of paint. We clean up at the end of every workday, not just at the end of the job.",
  },
];
